/** Lecture des cookies non-httpOnly posés par `setAuthCookies` côté serveur. */

const CSRF_COOKIE = "constrigo_csrf";
const SESSION_HINT_COOKIE = "constrigo_session";

function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
}

export function createCookieReaders(cookieScope?: string) {
  const scoped = cookieScope ? cookieScope.toLowerCase() : null;

  return {
    /** Jeton CSRF à renvoyer en en-tête (double-submit). */
    readCsrf(): string | null {
      if (scoped) {
        const s = readCookie(`${CSRF_COOKIE}_${scoped}`);
        if (s) return s;
      }
      return readCookie(CSRF_COOKIE);
    },

    /**
     * Instant d'expiration du jeton d'accès (epoch ms), ou `null` si aucune
     * session n'existe.
     *
     * Ce cookie vit aussi longtemps que le refresh (30 j), pas que l'accès
     * (1 h) : c'est ce qui permet de savoir, une heure après, qu'il reste une
     * session à rafraîchir. Les fronts se basaient auparavant sur le cookie
     * CSRF — expirant à 1 h — et concluaient donc « déconnecté » sans même
     * tenter `auth.me`.
     */
    readSessionExpiry(): number | null {
      const raw = scoped
        ? readCookie(`${SESSION_HINT_COOKIE}_${scoped}`) ?? readCookie(SESSION_HINT_COOKIE)
        : readCookie(SESSION_HINT_COOKIE);
      if (!raw) return null;
      const ts = Number(raw);
      return Number.isFinite(ts) && ts > 0 ? ts : null;
    },
  };
}

export type CookieReaders = ReturnType<typeof createCookieReaders>;
